var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "49px",
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-230.000000, -34.000000)",
    fill: "#54575A"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.941125, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4832535,33.3878141 L32.8133971,36.0863787 L24.2009571,27.4739386 L15.5885171,36.0863787 L12.9186607,33.3878141 L21.5311007,24.7753741 L12.9186607,16.162934 L15.5885171,13.4930776 L24.2009571,22.1055177 L32.8133971,13.4930776 L35.4832535,16.162934 L26.8708135,24.7753741 L35.4832535,33.3878141 Z M24,0.746666683 C10.7454545,0.746666683 0,11.4921211 0,24.7466667 C0,38.0040824 10.7454545,48.7466667 24,48.7466667 C37.2545455,48.7466667 48,38.0040824 48,24.7466667 C48,24.7351831 48,24.7294415 48,24.7179582 C48,11.477767 37.2688995,0.746666683 24.0287081,0.746666683 C24.0172249,0.746666683 24.0114833,0.746666683 24,0.746666683 L24,0.746666683 Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilled);
export default __webpack_public_path__ + "static/media/close-filled.0475b7102311c13f894bd779baa2fded.svg";
export { ForwardRef as ReactComponent };